/**
 * Created by Jerker Nord on 2019-09-02.
 */
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {BonusBunniesFreeSpinOutroController} from "./BonusBunniesFreeSpinOutroController";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {BonusBunniesInitialWinCountUp} from "../../winpresentation/initial/BonusBunniesInitialWinCountUp";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BigWinCoinsFountain} from "../../coinfountain/BigWinCoinsFountain";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";

export class BonusBunniesFreeSpinOutroView extends ScreenView {

    protected readonly DEFAULT_MOBILE_SCALE:number = 1;
    protected readonly DEFAULT_PORTRAIT_SCALE:number = 1;

    private _container:PIXI.Container;
    private _youWonText:PIXI.Text;
    private _numberOfSpinsText:PIXI.BitmapText;
    private _betMultipliedText:PIXI.Text;
    private _spinsPlayed:PIXI.Text;
    private _numberOfSpins:number = 0;
    private _winAmount:number = 0;
    private _blackGfx:PIXI.Graphics;
    private _darkenBackground:PIXI.Graphics;
    private _winCountUpYellow:BonusBunniesInitialWinCountUp;
    private reelsEnteringBonus:string[][];
    private _fsOutro:PIXI.spine.Spine;
    private _coinsFountainContainer:PIXI.Container;
    private _coinsFountain:BigWinCoinsFountain;
    private _clicker:PIXI.Graphics;
    private _isAborted:boolean;
    private _outroTL:TimelineLite;
    private _singleWin:number;
    private _onShowComplete:() => void;
    private _soundDelayTL:TimelineLite;
    private _totalBonusWinMultiplierAfter:number;
    private _winBlowStake:boolean = false;

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
        this._winCountUpYellow = new BonusBunniesInitialWinCountUp(BonusBunniesGameConfig.TEXT_STYLES.COUNTUP_YELLOW_BITMAP_STYLE);
        this._coinsFountainContainer = new PIXI.Container();
        this._coinsFountainContainer.position.set(-360, -260);
    }

    protected initAnimations():void {
        super.initAnimations();
        this._blackGfx = new PIXI.Graphics();
        this._blackGfx.alpha = 0;
        this.addChild(this._blackGfx);
        this._clicker = new PIXI.Graphics();
        this._clicker.on('pointertap', () => this.onAbortClick(), this);
        this._clicker.interactive = true;
        this._clicker.buttonMode = true;
    }

    private onAbortClick():void {
        if(this._isAborted == true) {
            return;
        }
        this._isAborted = true;
        this.removeChild(this._clicker);
        if(this._outroTL && this._outroTL.isActive()) {
            this._outroTL.pause();
            this._outroTL.kill();
        }
        this._coinsFountain.stopFountain();
        if(this._soundDelayTL && this._soundDelayTL.isActive()) {
            this._soundDelayTL.pause();
            this._soundDelayTL.kill();
        }
        SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.BONUS_ENDS_COIN_FOUNTAIN);
        SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.BONUS_ENDS_SMALL);
        SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.BONUS_ENDS_BIG);
        SlotGame.sound.fadeAmbience(1, 0);
        SlotGame.sound.playAmbience(BonusBunniesSoundConfig.instance.MAIN_GAME_AMBIANCE, 0, 1500);
        if(this._totalBonusWinMultiplierAfter < 60) {
            SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_COUNTUP_ENDS_SMALL);
        } else {
            SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_COUNTUP_ENDS_BIG);
        }
        this._winCountUpYellow.getCountUpAnimation(this._singleWin, this._singleWin, 0, 1);
        SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.COUNTUP);
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.COUNTUP_ENDS);
        this._onShowComplete();
    }

    protected setButtonPosition(data:IResizeData):void {
        super.setButtonPosition(data);
        this._button.position.y = ((data.height - 720) / 2) + 596;
    }

    public updateText(spinsPlayed:number, totalWin:number):void {
        this._numberOfSpins = spinsPlayed;
        this._winAmount = totalWin;
        this._numberOfSpinsText.text = "" + this._numberOfSpins;
    }

    public enableButton() {
        this._button.visible = true;
        super.enableButton();
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const cont:PIXI.Container = new PIXI.Container();

        this._darkenBackground = new PIXI.Graphics();
        this._darkenBackground.alpha = 0.5;

        this._fsOutro = new PIXI.spine.Spine(GameResources.getSpineAsset("FSOutro"));

        this._youWonText = new PIXI.Text(Translation.translate(""), BonusBunniesGameConfig.TEXT_STYLES.FREESPIN_OUTRO_YOU_WON);

        this._numberOfSpinsText = new PIXI.BitmapText("" + this._numberOfSpins, {
            fontName:BonusBunniesGameConfig.TEXT_STYLES.FREESPIN_OUTRO_NUMBER.font.name!,
            fontSize:BonusBunniesGameConfig.TEXT_STYLES.FREESPIN_OUTRO_NUMBER.font.size,
        });
        this._spinsPlayed = new PIXI.Text(Translation.translate("SPINS PLAYED"), BonusBunniesGameConfig.TEXT_STYLES.FREESPIN_OUTRO_SPINS_PLAYED);
        this._betMultipliedText = new PIXI.Text("", BonusBunniesGameConfig.TEXT_STYLES.FREESPIN_OUTRO_SPINS_PLAYED);

        this._youWonText.anchor.set(0.5, 0.5);
        this._spinsPlayed.anchor.set(0.5, 0.5);
        this._betMultipliedText.anchor.set(0.5, 0.5);
        this._numberOfSpinsText.anchor = new PIXI.Point(0.5, 0.5);

        this._youWonText.position.set(0, -240);
        this._betMultipliedText.position.set(0, -180);
        this._winCountUpYellow.position.set(0, -60);
        this._spinsPlayed.position.set(0, 60);
        this._numberOfSpinsText.position.set(0, 120);

        cont.addChild(this._darkenBackground);
        cont.addChild(this._fsOutro);
        cont.addChild(this._youWonText);
        cont.addChild(this._betMultipliedText);
        cont.addChild(this._winCountUpYellow);
        cont.addChild(this._numberOfSpinsText);
        cont.addChild(this._spinsPlayed);
        cont.addChild(this._coinsFountainContainer);

        this._container = cont;
        return this._container;
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);
        this.position.x = 0 - (Math.ceil(resizeData.width / this._layer.scale.x) - 720) / 2;
        this.position.y = 0 - (Math.ceil(resizeData.height / this._layer.scale.y) - 720) / 2;

        this._screenWidth = Math.ceil(resizeData.width / this._layer.scale.x);
        this._screenHeight = Math.ceil(resizeData.height / this._layer.scale.y);
        const leftOffset:number = Math.floor(-this._layer.x / this._layer.scale.x);
        const topOffset:number = Math.floor(-this._layer.y / this._layer.scale.y);

        this._clicker.clear();
        this._clicker.beginFill(0xFF0000, 1);
        this._clicker.alpha = 0;
        this._clicker.drawRect(leftOffset, topOffset, this._screenWidth, this._screenHeight);
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        this._blackGfx.clear();
        this._blackGfx.beginFill(0x000000);
        this._blackGfx.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._blackGfx.endFill();

        this._darkenBackground.clear();
        this._darkenBackground.beginFill(0x000000);
        this._darkenBackground.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._darkenBackground.endFill();
        this._darkenBackground.position.set(-this._darkenBackground.width * 0.5, -this._darkenBackground.height * 0.5);
    }

    protected startPresentation(data:BonusBunniesParsedGameData, onShowComplete?:() => void):void {
        this._winBlowStake = BonusBunniesGameModuleConfig.featurePrice.isWinBelowStake();
        this._onShowComplete = onShowComplete!;
        this._singleWin = data.singleWin;
        this._button.visible = false;
        this._isAborted = false;
        this._totalBonusWinMultiplierAfter = data.totalBonusWinMultiplierAfter;

        SlotGame.sound.fadeAmbience(0, 0);

        this._soundDelayTL = new TimelineLite();
        if(this._winBlowStake) {

        } else if(this._totalBonusWinMultiplierAfter < 60) {
            SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_ENDS_SMALL);
            this._soundDelayTL.add(() => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_COUNTUP_ENDS_SMALL), "+=3.692");
        } else {
            SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_ENDS_BIG);
            this._soundDelayTL.add(() => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_COUNTUP_ENDS_BIG), "+=3.692");
        }

        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView.hideBonusSpinsCounter();
        BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.hideWinText();
        this._coinsFountain = BonusBunniesGameModuleConfig.bonusBunniesBigWinController.getCoinFountain();
        this._coinsFountainContainer.addChild(BonusBunniesGameModuleConfig.bonusBunniesBigWinController.getCoinFountainContainer());
        this.reelsEnteringBonus = data.reelsEnteringBonus;
        this._betMultipliedText.text = SlotGame.api.currency.format(data.playedBetValue) + " x " + this._totalBonusWinMultiplierAfter;
        this.alpha = 0;
        this._blackGfx.alpha = 0;
        this._container.alpha = 1;
        this._button.alpha = 1;
        if(this._autoCloseTimer) {
            this._autoCloseTimer.alpha = 1;
        }
        const spinsPlayed = data.bonusSpinsPlayed ? data.bonusSpinsPlayed : 0;
        this.updateText(spinsPlayed, data.singleWin);

        this._fsOutro.state.setAnimation(0, "base", true);

        if(this._outroTL && this._outroTL.isActive()) {
            this._outroTL.pause();
            this._outroTL.kill();
        }
        this._outroTL = new TimelineLite();
        this._outroTL.add(new TweenLite(this, 1, {alpha : 1, ease : Linear.easeNone}));
        this._outroTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.isExtraRow = false);
        this._outroTL.add(() => this._winCountUpYellow.currentWinRatio = WinRatioType.LARGE);
        this._outroTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController.disableChest());
        if(this._winBlowStake){
            this._outroTL.add([
                this._winCountUpYellow.getCountUpAnimation(0, parseFloat(data.accumulatedRoundWin), 0, 1),
                () => SlotGame.sound.fadeAmbience(1, 0),
                () => SlotGame.sound.playAmbience(BonusBunniesSoundConfig.instance.MAIN_GAME_AMBIANCE, 0, 1500)
            ]);
            this._outroTL.add([
                ()=> SlotGame.keypad.setWin(parseFloat(data.accumulatedRoundWin), true, BonusBunniesGameModuleConfig.featurePrice.isWinBelowStake())
            ]);
        } else {
            this._outroTL.add([
                () => this._coinsFountain.startFountain(4),
                this._winCountUpYellow.getCountUpAnimation(0, parseFloat(data.accumulatedRoundWin), 2.75, 1),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_ENDS_COIN_FOUNTAIN),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.COUNTUP, 100),
                () => this.addChild(this._clicker)
            ]);
            this._outroTL.add([
                ()=> SlotGame.keypad.setWin(parseFloat(data.accumulatedRoundWin), true, BonusBunniesGameModuleConfig.featurePrice.isWinBelowStake())
            ]);
            this._outroTL.add([
                () => this._coinsFountain.stopFountain(),
                () => SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.COUNTUP),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.COUNTUP_ENDS),
                () => SlotGame.sound.fadeAmbience(1, 0),
                () => SlotGame.sound.playAmbience(BonusBunniesSoundConfig.instance.MAIN_GAME_AMBIANCE, 0, 1500)
            ]);
        }

        if(onShowComplete) {
            this._outroTL.add(() => this._isAborted = true);
            this._outroTL.add(() => this.removeChild(this._clicker));
            this._outroTL.add(() => {
                onShowComplete()
            });
        }
    }

    protected stopPresentation(closeCallback?:() => void):void {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => this._coinsFountain.stopFountain());
        timeline.add(this.fadeInBlack());
        timeline.add(() => {
            this._container.alpha = 0;
            this._button.alpha = 0;
            if(this._autoCloseTimer) {
                this._autoCloseTimer.alpha = 0;
            }
        });
        timeline.add(() => BonusBunniesFreeSpinOutroController.actuallyDoTransition());
        timeline.add(() => this.restoreBaseGameReels());
        timeline.add(new TweenLite(this, 1, {alpha : 0, ease : Linear.easeNone}));
        timeline.add(() => super.stopPresentation(closeCallback));
    }

    private restoreBaseGameReels():void {
        for(let i:number = 0; i < this.reelsEnteringBonus.length; i++) {
            for(let j:number = 1; j < this.reelsEnteringBonus[i].length; j++) {
                if(this.reelsEnteringBonus[i][j] == "BW") {
                    this.reelsEnteringBonus[i][j] = "BEmpty";
                }
                if(this.reelsEnteringBonus[i][j] == "W") {
                    this.reelsEnteringBonus[i][j] = "WExpand";
                }
                (Reels.getSymbol(i, j - 1)!).replaceWith(this.reelsEnteringBonus[i][j], i);
                if(this.reelsEnteringBonus[i][j] == "B") {
                    Reels.moveSymbolToTop(i, j - 1);
                }
            }
        }
    }

    private fadeInBlack():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this._blackGfx, 1, {alpha : 1, ease : Linear.easeNone}));
        return tl;
    }
}
